import { useSelector } from "react-redux";
import { DOMICILE } from "../../redux/slices/api/initialisePreferences";
import { isIntranetPath } from "../routing";
import { features } from "../../app/features";
import useIsMobile from "./useIsMobile";

/**
 * Returns true when the AI Summary button should be shown for a given publication.
 * Conditions:
 *  - features.chatbot.showAiSummaryButton is enabled (controls dev/uat/prod)
 *  - publication.aiSummary === true
 *  - user is on the intranet (internal)
 *  - user domicile is not "ja"
 *  - user is not on a mobile device
 */
export function useShowAiSummary(publication) {
  const domicile = useSelector((state) => state.preferences[DOMICILE])[0];
  return (
    features.chatbot.showAiSummaryButton &&
    !!publication?.aiSummary &&
    isIntranetPath() &&
    domicile !== "ja" &&
    !useIsMobile()
  ); 
}
